import { t } from "i18next";
import { useEffect, useState } from "react";
import { LoadingSpinner } from "../../general/loading-spinner";
import { Link, useParams } from "react-router-dom";
import { Alert, Col, Image, Row } from "react-bootstrap";
import { getAthleteSingle } from "../../../services/athlete";
import { Athlete, AthleteTeamSeason, emptyAthlete } from "../../../interfaces/athlete";
import moment from 'moment';
import { countriesList } from "../../../data/countries";
import teamsGreenIcon from "../../../assets/images/teams.svg";
import rankingIcon from "../../../assets/images/rankings.svg";
import { AthleteWeightChart } from "../../charts/athlete-weight-chart";
import { AthleteBMIChart } from "../../charts/athlete-bmi-chart";
import { AthleteFMChart } from "../../charts/athlete-fm";
import { AthleteBMChart } from "../../charts/athlete-bm";
import { AthletePerformanceEvolutionChart } from "../../charts/athlete-performance-evolution-chart";

export function AthleteView() {
    const params: any = useParams();

    const [loaded, setLoaded] = useState(false);
    const [athlete, setAthlete] = useState<Athlete>(emptyAthlete);

    useEffect(() => {
        Promise.all([
            getAthleteSingle(params.id)
        ]).then(response => {
            console.log(response[0].data);
            setAthlete(response[0].data);
            setLoaded(true);
        });
    }, []);
    
    return (
        <div className="athlete-view-container"> 
            <div className="inner">
                { !loaded && 
                    <LoadingSpinner />
                }
                { loaded && 
                    <div className="athlete-content">
                        <h1>{ athlete.name }</h1>
                        <Row>
                            <Col xs={12} md={6}>
                                <div className="content-data content-box">
                                    { athlete.avatar.length > 0 &&
                                        <Image src={ athlete.avatar[0].url } roundedCircle />
                                    }
                                    <div className="content-item mt-4">
                                        <span className="label">{ t("Name") }</span>: { athlete.first_name }
                                    </div>
                                    <div className="content-item">
                                        <span className="label">{ t('last_name') }</span>: { athlete.last_name }
                                    </div>
                                    <div className="content-item mb-2">
                                        <span className="label">{ t('document_id') }</span>: { athlete.document_id }
                                    </div>
                                    <div className="content-group mb-2">
                                        <div className="legend">{ t("birth") }</div>
                                        <div className="content-wrapper">
                                            { athlete.birthdate &&
                                                <div className="content-item">
                                                    <span className="label">{ t('birthdate') }</span>: { moment(athlete.birthdate).format('DD/MM/Y') }
                                                </div>
                                            }
                                            <div className="content-item">
                                                <span className="label">{ t('birth_city') }</span>: { athlete.birth_city }
                                            </div>
                                            <div className="content-item">
                                                <span className="label">{ t('birth_region') }</span>: { athlete.birth_region }
                                            </div>
                                            <div className="content-item">
                                                <span className="label">{ t('birth_country') }</span>: { countriesList.filter((c: any) => c.code == athlete.birth_country).length > 0 ? countriesList.filter((c: any) => c.code == athlete.birth_country)[0].name : '' }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="content-group mb-2">
                                        <div className="legend">{ t("contact_info") }</div>
                                        <div className="content-wrapper">
                                            <div className="content-item">
                                                <span className="label">{ t('address') }</span>: { athlete.address }
                                            </div>
                                            <div className="content-item">
                                                <span className="label">{ t('city') }</span>: { athlete.city }
                                            </div>
                                            <div className="content-item">
                                                <span className="label">{ t('country') }</span>: { countriesList.filter((c: any) => c.code == athlete.country).length > 0 ? countriesList.filter((c: any) => c.code == athlete.country)[0].name : '' }
                                            </div>
                                            <div className="content-item">
                                                <span className="label">{ t('email') }</span>: { athlete.email }
                                            </div>
                                            <div className="content-item">
                                                <span className="label">{ t('phone') }</span>: { athlete.phone }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="content-item">
                                        <Alert key={'description'} variant={'secondary'}>
                                            { athlete.description }
                                        </Alert>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} md={6}>
                                { athlete.ranking.length > 0 &&
                                    <div className="block block-ranking">
                                        <div className="block-inner">
                                            <h3 className="block-title">
                                                <img src={ rankingIcon } alt={ t("Ranking")} />
                                                { t("Ranking") }
                                            </h3>
                                            <div className="block-content">
                                                <div className="ranking-data">
                                                    <div className="points">
                                                        { athlete.ranking[athlete.ranking.length - 1].points } <span>{ t("points_label") }</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                { athlete.registered_in.length > 0 &&
                                    <div className="block block-teams-mini">
                                        <div className="block-inner">
                                            <h3 className="block-title">
                                                <img src={ teamsGreenIcon } alt={ t("teams")} />
                                                { t("teams") }
                                            </h3>
                                            <div className="block-content">
                                                {
                                                    athlete.registered_in.slice(0, 10).map((ats: AthleteTeamSeason) => {
                                                        return <div key={ 'team-' + ats.id } className="team-tile">
                                                                <div className="title">
                                                                    <Link to={ '/teams/' + ats.team_id + '/view' }  title={ ats.team_name }>
                                                                        { ats.team_name }
                                                                    </Link>
                                                                </div>
                                                                <div className="season">
                                                                    { t("season") } { ats.season_name }
                                                                </div>
                                                                <div className="club">
                                                                    { t("club") } { ats.club_name }
                                                                </div>
                                                            </div>
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                            </Col>
                        </Row>
                        { athlete.performance && athlete.performance.length > 0 &&
                            <Row>
                                <Col xs={12}>
                                    <AthletePerformanceEvolutionChart performance={ athlete.performance } />
                                </Col>
                            </Row>
                        }
                        { athlete.measurement.length > 0 &&
                            <Row>
                                <Col xs={12} md={6}>
                                    <AthleteWeightChart athlete={ athlete } />
                                </Col>
                                <Col xs={12} md={6}>
                                    <AthleteBMIChart athlete={ athlete } />
                                </Col>
                                <Col xs={12} md={6}>
                                    <AthleteBMChart athlete={ athlete } />
                                </Col>
                                <Col xs={12} md={6}>
                                    <AthleteFMChart athlete={ athlete } />
                                </Col>
                            </Row>
                        }
                    </div>
                }
            </div>
        </div>
    );
}
